import { createContext } from "react";
const RatingsProvider = createContext();
export default RatingsProvider;
